import Routers from "./router";
import stockStore from './store'
export default {
    install(vue, {router,store}){
        router.addRoute(Routers)
        store.registerModule('stockModule', stockStore)
    }
}